import { Injectable } from "@angular/core";
import { ValidatorFn, AbstractControl, FormArray, FormGroup } from "@angular/forms";
import { DwValidationError, DwValidationErrorResult, DwValidationItemType, DwValidationRule, DwValidationRuleBase } from "@devwareapps/devware-cap";
import * as moment from "moment";
import { AssignmentEntity, AssignmentStudentEntity } from "../../../meta-data/app-meta-data.service";


const errorProperty = 'studentCountError';
const errorFilterKey = 'assignment-student-count';
@DwValidationRule({
    keyName: 'assignment_student_count_validator',
    display: 'Assignment Student Count Validator',
    errorType: errorProperty,
    validationItemType: DwValidationItemType.formGroup,
    messageTemplate: 'At least one student must be selected',
})
@Injectable()
export class DwAssignmentStudentCountValidationRule extends DwValidationRuleBase {
    createValidator(config?: any, context?: any) {
        return ValidateLessonCount(config, context);
    } 

    getMessageTemplate(error: DwValidationError<any>, displayName: string, isSubmitted: boolean, messageTemplate?: string): string {
        return messageTemplate;
    }
}

export function ValidateLessonCount(config: any, context?: any): ValidatorFn {
    return (control: AbstractControl) => {
        let studentCount = 0;

        if (control instanceof FormArray) {
            const assignmentStudents = (control.getRawValue() || []) as AssignmentStudentEntity[];
            studentCount = assignmentStudents.filter(student => !student._isDeleted).length;
        } else {
            const formGroup = control as FormGroup;
            const assignment : AssignmentEntity = formGroup?.getRawValue();

            if (assignment?.UseGroupAssignment) {
                return null;
            }

            if (assignment?.AssignmentStudent) {
                studentCount = assignment.AssignmentStudent.filter(student => !student._isDeleted).length;
            }
        }


        if (studentCount == 0) {
            const result: DwValidationErrorResult<any> = {};
            result[errorProperty] = {
                value: true,
                filterKey: context?.validationKey || errorFilterKey
            };

            return result;
        } 

        return null;
    }
}
